import { AuthActions } from "../LoginRedux/Action";
import { ColdChainDashActions } from "./action";

let cancelOrderState = {
  coldChainDashboardData: null,
  coldChainDashboardError: null,
  coldChainCSVData: null,
  coldChainCSVError: null,
  markDeliveredData: null,
  markDeliveredError: null,
  handDeliveredData: null,
  handDeliveredError: null,
  getRoleData: null,
  getRoleError: null,
  getRoleIDData: null,
  getRoleIDError: null,
  assignRunnerData: null,
  assignRunnerError: null,
};

export const coldChainDashReducer = (
  state = cancelOrderState,
  { type, payload }
) => {
  switch (type) {
    case ColdChainDashActions.COLDCHAIN_DASHBOARD_SUCCESS:
      return {
        ...state,
        coldChainDashboardData: payload,
        coldChainDashboardError: null,
      };

    case ColdChainDashActions.COLDCHAIN_DASHBOARD_FAILURE:
      return {
        ...state,
        coldChainDashboardData: null,
        coldChainDashboardError: payload,
      };

    case ColdChainDashActions.COLDCHAIN_MANIFEST_SUCCESS:
      return {
        ...state,
        coldChainCSVData: payload,
        coldChainCSVError: null,
      };

    case ColdChainDashActions.COLDCHAIN_MANIFEST_FAILURE:
      return {
        ...state,
        coldChainCSVData: null,
        coldChainCSVError: payload,
      };

    case ColdChainDashActions.MARK_DELIVERED_SUCCESS:
      return {
        ...state,
        markDeliveredData: payload,
        markDeliveredError: null,
      };

    case ColdChainDashActions.MARK_DELIVERED_FAILURE:
      return {
        ...state,
        markDeliveredData: null,
        markDeliveredError: payload,
      };

    case ColdChainDashActions.HAND_DELIVERED_SUCCESS:
      return {
        ...state,
        handDeliveredData: payload,
        handDeliveredError: null,
      };

    case ColdChainDashActions.HAND_DELIVERED_FAILURE:
      return {
        ...state,
        handDeliveredData: null,
        handDeliveredError: payload,
      };

    case ColdChainDashActions.GET_ROLE_SUCCESS:
      return {
        ...state,
        getRoleData: payload,
        getRoleError: null,
      };

    case ColdChainDashActions.GET_ROLE_FAILURE:
      return {
        ...state,
        getRoleData: null,
        getRoleError: payload,
      };

    case ColdChainDashActions.GET_ROLE_ID_SUCCESS:
      return {
        ...state,
        getRoleIDData: payload,
        getRoleIDError: null,
      };

    case ColdChainDashActions.GET_ROLE_ID_FAILURE:
      return {
        ...state,
        getRoleIDData: null,
        getRoleIDError: payload,
      };

    case ColdChainDashActions.ASSIGN_RUNNER_SUCCESS:
      return {
        ...state,
        assignRunnerData: payload,
        assignRunnerError: null,
      };

    case ColdChainDashActions.ASSIGN_RUNNER_FAILURE:
      return {
        ...state,
        assignRunnerData: null,
        assignRunnerError: payload,
      };

    default:
      return state;
  }
};
